import { render } from "./SelectStudentsForm.vue?vue&type=template&id=360564fa&scoped=true"
import script from "./SelectStudentsForm.vue?vue&type=script&lang=js"
export * from "./SelectStudentsForm.vue?vue&type=script&lang=js"

import "./SelectStudentsForm.vue?vue&type=style&index=0&id=360564fa&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360564fa"]])

export default __exports__